<template>
  <div class="flowCenter">
        <ul>
            <li class="clear" v-for="(item, index) in menuList" :key="index" :class="type === index ? 'active' : ''" @click="tabIndex(type, index, item.href)">
                <!-- <router-link :to="item.href"> -->
                    <img class="fl" :src="item.icon" alt="加载失败" width="30px" height="30px">
                    <span class="fl">{{item.title}}</span>
                <!-- </router-link> -->
            </li>
        </ul>
  </div>
</template>
<script>

export default {
  data () {
    return {
      type: 0,
      menuList: [
        {
          title: '流量充值',
          href: '/flowCenter',
          icon: require('../assets/images/icon/icon_recharge.png'),
          type: 0
        },
        {
          title: '淘宝任务',
          href: '/tbTask',
          icon: require('../assets/images/icon/icon_taobao.png'),
          type: 1
        },
        {
          title: '京东任务',
          href: '/jdApp',
          icon: require('../assets/images/icon/icon_jd.png'),
          type: 2
        },
        {
          title: '拼多多任务',
          href: '/pddApp',
          icon: require('../assets/images/icon/icon_pdd.png'),
          type: 3
        },
        // {
        //   title: '抖音任务',
        //   href: '/douyinFollow',
        //   icon: require('../assets/images/icon/icon_douyin.png'),
        //   type: 4
        // },
        {
          title: '任务模板',
          href: '/taskTemplate',
          icon: require('../assets/images/icon/icon_model.png'),
          type: 5
        },
        {
          title: '任务查询',
          href: '/taskSearch',
          icon: require('../assets/images/icon/icon_search.png'),
          type: 6
        }
      ]
    }
  },
  created () {
    this.getPath()
  },
  methods: {
    tabIndex (type, index, page) {
      this.type = index
      this.$router.push({path: page})
    },
    getPath () {
      let _this = this
      let paths = _this.$route.path
      if (paths.indexOf('flowCenter') !== -1) {
        _this.type = 0
      } else if (paths.indexOf('tbTask') !== -1 || paths.indexOf('tbCollection') !== -1 || paths.indexOf('tbAdd') !== -1 ||
      paths.indexOf('tbPc') !== -1 || paths.indexOf('tblike') !== -1 || paths.indexOf('tbpassw') !== -1 || paths.indexOf('wangwang') !== -1 ||
      paths.indexOf('linkes') !== -1 || paths.indexOf('tbPassw') !== -1 || paths.indexOf('tbLike') !== -1 || paths.indexOf('tbDayGood') !== -1 ||
      paths.indexOf('tbGoodCollection') !== -1 || paths.indexOf('tbShopCollection') !== -1 || paths.indexOf('tbJuhuasuan') !== -1 ||
      paths.indexOf('tbDirectPurchase') !== -1 || paths.indexOf('tbRushToBuy') !== -1 || paths.indexOf('tbDaRen') !== -1 || paths.indexOf('tbLive') !== -1 || paths.indexOf('guangguang') !== -1) {
        _this.type = 1
      } else if (paths.indexOf('jdApp') !== -1 || paths.indexOf('jdAdd') !== -1 || paths.indexOf('jdCollection') !== -1 || paths.indexOf('jdDirectCollection') !== -1 ||
      paths.indexOf('jdSearchCollection') !== -1 || paths.indexOf('jdDirectAdd') !== -1) {
        _this.type = 2
      } else if (paths.indexOf('pddApp') !== -1 || paths.indexOf('pddCollection') !== -1 || paths.indexOf('pddGoodCollection') !== -1 || paths.indexOf('pddShopCollection') !== -1) {
        _this.type = 3
      } else if (paths.indexOf('taskTemplate') !== -1) {
        _this.type = 5
      } else if (paths.indexOf('taskSearch') !== -1) {
        _this.type = 6
      } else if (paths.indexOf('douyinFollow') !== -1 || paths.indexOf('douyinAdd') !== -1 || paths.indexOf('douyinPlay') !== -1) {
        _this.type = 4
      }
    }

  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
.flowCenter {
  min-height: 600px;
  li.active {
    color: #FF8301;
  }
}

.main-left {
    ul {
        border-right: 2px solid #EEEEEE;
        li {
            padding: 25px 12px;
            span {
                line-height: 33px;
                font-size: 16px;
                // color: #333333;
                margin-left: 10px;
                cursor: pointer;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue